import React from "react";
import { Page, Text, View, Document, StyleSheet, pdf } from "@react-pdf/renderer";
import PDFDownloader from "../../../Components/PDFDownloader/PDFDownloader";
const productData = [
  { naam: "Prei", waarde: "7 stuks" },
  { naam: "Champignons", waarde: "5 bakjes" },
  { naam: "Courgette", waarde: "6 stuks" },
  { naam: "Rijst", waarde: "3 dozen" }
];

const vleesData = [
  { klas: "Z2", leerkracht: "Dhr. Janssen", datum: "17 februari", product: "Kipfilet - 2 kg" },
  { klas: "B1", leerkracht: "Mevr. Peeters", datum: "17 februari", product: "Rundergehakt - 1.5 kg" },
  { klas: "C3", leerkracht: "Dhr. Willems", datum: "17 februari", product: "Speklappen - 1 kg" },
  { klas: "D4", leerkracht: "Mevr. De Vries", datum: "17 februari", product: "Biefstuk - 3 stuks" }
];

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12 },
  title: { fontSize: 18, marginBottom: 10, textAlign: 'center', fontWeight: 'bold' },
  table: { width: '100%', marginTop: 10, borderTopWidth: 1, borderColor: 'black' },
  row: { flexDirection: 'row', borderBottomWidth: 1, borderColor: 'black', padding: 5 },
  headerRow: { backgroundColor: '#333', color: 'white', flexDirection: 'row', padding: 8 },
  cellHeader: { flex: 1, fontWeight: 'bold', textAlign: 'left' },
  cell: { flex: 1, textAlign: 'left' },
});

// Generate product data dynamically
const generateProductData = () => {
  const products = [];
  for (let i = 1; i <= 20; i++) {
    products.push({
      naam: `Product ${i}`,
      waarde: `${i * 10} units`,
    });
  }
  return products;
};

// Define the ProductPDF component
const ProductPDF = () => {
  const productData = generateProductData();

  return (
    <Document>
      {productData.map((item, index) => {
        // Start a new page after every 50 items (adjust as necessary based on page size)
        if (index % 50 === 0) {
          return (
            <Page key={index} style={styles.page}>
              <Text style={styles.header}>Lijst van Bestelde Producten</Text>

              {/* Add content for the first page */}
              {productData.slice(index, index + 50).map((product, idx) => (
                <View key={idx} style={styles.section}>
                  <Text style={styles.productText}>• {product.naam}: {product.waarde}</Text>
                </View>
              ))}
            </Page>
          );
        } else {
          return (
            <Page key={index} style={styles.page}>
              <Text style={styles.header}>Lijst van Bestelde Producten</Text>

              {/* Add content for the current page */}
              {productData.slice(index, index + 50).map((product, idx) => (
                <View key={idx} style={styles.section}>
                  <Text style={styles.productText}>• {product.naam}: {product.waarde}</Text>
                </View>
              ))}
            </Page>
          );
        }
      })}
    </Document>
  );
};


const VleesPDF = () => (
  
  <Document>
    <Page style={styles.page}>
      
      <Text style={styles.title}>Vlees Bestelling</Text>
      <View style={styles.table}>
        <View style={styles.headerRow}>
          <Text style={styles.cellHeader}>Leerkracht</Text>
          <Text style={styles.cellHeader}>Datum</Text>
          <Text style={styles.cellHeader}>Product</Text>
        </View>
        {vleesData.map((item, index) => (
          <View key={index} style={styles.row}>
            <Text style={styles.cell}>{item.klas}</Text>
            <Text style={styles.cell}>{item.leerkracht}</Text>
            <Text style={styles.cell}>{item.datum}</Text>
            <Text style={styles.cell}>{item.product}</Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

const PDF = () => {
  const generatePDF = async (documentComponent, filename) => {
    const blob = await pdf(documentComponent).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h1>Download de PDF-bestanden</h1>
      <button onClick={() => generatePDF(<ProductPDF />, "producten.pdf")}>Download Producten PDF</button>
      <button onClick={() => PDFDownloader.generateVleesPDF()} style={{ marginLeft: "10px" }}>
        Download Vlees PDF
      </button>
      <button onClick={() =>PDFDownloader.generateLogistiekPDF()}>Download Producten PDF</button>
    </div>
  );
};

export default PDF;
